"use strict";
import { bsc, bscTestnet } from "wagmi/chains";
import { UniverseChainId } from "./types";
export const bscMainnet = {
  ...bsc,
  id: UniverseChainId.Mainnet
};
export const bscTestnetChain = {
  ...bscTestnet,
  id: UniverseChainId.Sepolia
};
